<div class="page-container">
  <div class="registration-simple-header flex items-center">
    <a subdomainLink="/screen" [subdomainLinkType]="subdomainLinksTypes.LANDING">
      <div class="glabix-logo" style="height: 40px"></div>
    </a>
  </div>
</div>
